import Cookies from "js-cookie";

import eng from "./eng";
import heb from "./heb";

import { GEOCOUNTRY_COOKIE, ISRAEL_COUNTRY_CODE } from "constant";

export const getLabelsByLanguage = (language) => {
  return language === LANGUAGES.HE ? heb() : eng();
};

export const isRtlLanguage = (language) => {
  return language === LANGUAGES.HE;
};
/**
 *
 * @returns {typeof LANGUAGES[keyof typeof LANGUAGES]}
 */
export const getLanguageFromQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langFromParams = urlParams.get("language")?.toLowerCase() || LANGUAGES.EN;

  const allLanguages = Object.values(LANGUAGES);
  if (allLanguages.includes(langFromParams)) {
    return langFromParams;
  }

  return LANGUAGES.EN;
};

export const hasLanguageParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has("language");
};

export const isHebrewContext = () => {
  const pathname = window.location.pathname.toLowerCase();
  return pathname.includes("/he/");
};

export const shouldRunGeoCheck = () => {
  if (hasLanguageParam()) return false;
  if (isHebrewContext()) return false;
  return true;
};

export const getCountryCode = () => {
  return Cookies.get(GEOCOUNTRY_COOKIE) || null;
};

export const isFromIsrael = () => {
  const countryCode = getCountryCode();
  return countryCode?.toUpperCase() === ISRAEL_COUNTRY_CODE;
};

export const applyLanguageToUrl = (language) => {
  const url = new URL(window.location.href);
  url.searchParams.set("language", language);
  window.history.replaceState({}, "", url.toString());
};

export const LANGUAGES = /** @type {const} */ ({
  HE: "he",
  EN: "en",
});
